import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuBar} from 'mui-tiptap';

const StyledEditorMenuBar = styled(MenuBar)`
  ${ComponentStyles}
`;

StyledEditorMenuBar.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuBar;
